import { render, staticRenderFns } from "./numAndGaiLv.vue?vue&type=template&id=202a8b86&scoped=true&"
import script from "./numAndGaiLv.vue?vue&type=script&lang=js&"
export * from "./numAndGaiLv.vue?vue&type=script&lang=js&"
import style0 from "./numAndGaiLv.vue?vue&type=style&index=0&id=202a8b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a8b86",
  null
  
)

export default component.exports